import {
    type FC
} from "react";
import type ITableHeadProps from "./type";
import TableCellBase from "../../internal/cell";

const TableHead: FC<ITableHeadProps> = ({
    scope = "col",
    ...props
}) => {
    return <TableCellBase
        {...props}
        scope={scope}
        kind="head"
    />;
};
export default TableHead;
